import i18n from 'i18next';

const LanguageSwitcher = () => {
  return (
    <div style={{display: 'flex', justifyContent: 'center', gap: 20, cursor: 'pointer'}}>
      <div onClick={() => i18n.changeLanguage('en')}>🇺🇸 English</div>
      <div onClick={() => i18n.changeLanguage('es')}>🇪🇸 Español</div>
      <div onClick={() => i18n.changeLanguage('en-GB')}>🇬🇧 English (UK)</div>
    </div>
  );
}

export default LanguageSwitcher;